export default __webpack_public_path__ + "static/media/guide0301_m.37b9ca88.jpg";